module.exports = __webpack_public_path__ + "img/electricity-bulb.ad3499ae.svg";